export const HOME_PAGE = {
  HOME_PAGE_SET_SELECTED: "HOME_PAGE_SET_SELECTED",
  HOME_PAGE_CLEAR_SELECTED: "HOME_PAGE_CLEAR_SELECTED",
};
